export default "__VITE_ASSET__6b2b3e67__"